import * as all from './all/index';

function getKeys<T>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>;
}

export const ALL_ICON_KEYS = getKeys(all);

export type IconType = keyof typeof all;

export default function Icon(type: keyof typeof all) {
  if (!(ALL_ICON_KEYS.indexOf(type) > -1)) {
    throw new Error(`${type} is not a valid icon type name`);
  }

  return all[type];
}
